  <div class="container-fluid h-100" role="presentation">
		<div class="row h-100">
			<div class="col-md-12 no-padding login-layout">
				<div class="header">
					<div class="navigation-wrap">
						<a href="https://upscapital.com/" target="_blank" rel="noopener noreferrer">
              <img alt="UPS Capital" id="upsc-logo" src="https://online.upscapital.com/assets/images/logos/ca_us/InsureShield_Logo_226x79_larger_tagline-01.png">
						</a>
					</div>
				</div>
				<div class="page">
          <div class="d-flex justify-content-center align-items-center h-100">
            <div *ngIf="!errorOccurred && !showCodeVerification"  class="w-75 align-items-center" >
              <mat-progress-bar
                    [mode]="'indeterminate'">
              </mat-progress-bar>
            </div>
            <div *ngIf="errorOccurred" class="messageBox d-flex flex-column align-item-center">
              <p class="error">{{'autoAuth.error' | translate}}</p>
              <p class="message">
                <span>{{'autoAuth.tryAgain1' | translate}}</span>
                <a href="mailto:InsureShieldsupport@ups.com?subject={{ 'autoAuth.subject' | translate }}"><u> {{'autoAuth.email' | translate}} </u></a>
                <span>{{'autoAuth.tryAgain2' | translate}}</span></p>
              <div class="message">{{'autoAuth.hours' | translate}}</div>
              <div class="message">{{'autoAuth.days' | translate}}</div>
              <div class="message">{{'support.time' | translate}}</div>
            </div>
          </div>
        </div>
				<div class="footer">
					<div class="d-flex flex-column-reverse mb-3 mb-lg-4">
						<div id="divFooter">
							<div class="footer-wrap-left mt-3">
								<div class="footer-align">
									<div class="break"></div>
									<div class="footer-link"><a
											href="http://www.ups.com/content/us/en/resources/ship/terms/use.html" target="_blank"
											rel="noopener noreferrer"> Website Terms of Use<i class="bi bi-box-arrow-up-right"></i></a>
                      <span class="vertical-border"></span>
									</div>
									<div class="footer-link"><a
											href="https://www.insureshield.com/us/en/legal/technology-agreement.html" target="_blank"
											rel="noopener noreferrer">
											Technology Agreement<i class="bi bi-box-arrow-up-right"></i></a>
                      <span class="vertical-border"></span>
									</div>
									<div class="footer-link"><a
											href=" https://www.insureshield.com/us/en/legal/product-disclosure.html" target="_blank"
											rel="noopener noreferrer">
											Product Disclosures<i class="bi bi-box-arrow-up-right"></i></a>
                      <span class="vertical-border"></span>
									</div>
									<div class="footer-link"><a
											href="http://www.ups.com/content/us/en/resources/ship/terms/california_privacy.html"
											target="_blank" rel="noopener noreferrer"> Your California Privacy Rights<i class="bi bi-box-arrow-up-right"></i></a>
                      <span class="vertical-border"></span>
									</div>
									<div class="footer-link"><a
											href="https://www.insureshield.com/us/en/legal/privacy-notice.html" target="_blank"
											rel="noopener noreferrer"> Privacy Notice<i class="bi bi-box-arrow-up-right"></i></a>
                      <span class="vertical-border"></span>
									</div>
									<div class="footer-link"><a
											href="javascript:window.OneTrust.ToggleInfoDisplay();window.scrollTo(0,0);">
											Cookie Settings </a>
                      <span class="vertical-border"></span>
                  </div>
									<div class="footer-link"><a href="https://upscapital.com/opt-out/" target="_blank"
											rel="noopener noreferrer"> Do Not Sell or Share My
											Personal Information<i class="bi bi-box-arrow-up-right"></i></a>
									</div>
								</div>

								<div class="copyright-left">Copyright © 2022 - 2024 United Parcel Service of America, Inc. All rights
									reserved. </div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
